import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuard } from "./core/services/auth.guard";

const routes: Routes = [
  { path: "", redirectTo: "login", pathMatch: "full"},
  { path: "login", loadChildren: () => import('./login/login.module').then(m => m.LoginModule) },
  { path: "admin", loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule) },
  { path: "venue", loadChildren: () => import('./venue/venue.module').then(m => m.VenueModule) }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
